export const IS_CONNECTING = 'app/loader/is_connecting';
export const IS_END_CONNECT = 'app/loader/is_end_connect';
